import module from 'recursoshumanos/module.js'
import template from './template.html'

export class RecursoshumanosVisolotesDescargasSuaComponent {
  idEmpresa
  clase
  registroPatronalId
  proyectos
  fecha
  onClose
  tipoMovimientoId = undefined
  actualizando = false
  completado = false
  movimientos = [{id: '8', descripcion: 'ALTAS'}, {id: '2', descripcion: 'BAJAS'}, {id: '7', descripcion: 'MODIFICACIÓN'}]

  constructor (RecursoshumanosVisorloteSUAAltasMasivasService) {
    this.RecursoshumanosVisorloteSUAAltasMasivasService = RecursoshumanosVisorloteSUAAltasMasivasService
  }

  descargar () {
    if (this.actualizando) return

    this.actualizando = true
    this.error = null

    let config = {idEmpresa: this.idEmpresa, clase: this.clase, proyectos: this.proyectos, tipoMovimientoId: this.tipoMovimientoId, fecha: this.fecha, registroPatronalId: this.registroPatronalId}

    this.RecursoshumanosVisorloteSUAAltasMasivasService.get(config)
      .then(({data}) => {
        data.save()
        this.onClose()
      })
      .catch(({data}) => (this.error = data))
      .finally(() => (this.actualizando = false))
  }

  cerrar () {
    this.onClose()
  }
}

module.component('recursoshumanosVisorlotesDescargasSua', {
  controller: RecursoshumanosVisolotesDescargasSuaComponent,
  template,
  bindings: {
    idEmpresa: '<',
    clase: '<',
    registroPatronalId: '<',
    proyectos: '<',
    fecha: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/visorlotes/descargas/sua/component.js